var Backbone, BreadcrumbIndexTemplate, BreadcrumbView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

BreadcrumbIndexTemplate = require('../../index.html.mustache');

module.exports = BreadcrumbView = (function(superClass) {
  var BREADCRUMB_SELECTOR;

  extend(BreadcrumbView, superClass);

  BREADCRUMB_SELECTOR = '#breadcrumb-container';

  BreadcrumbView.prototype.template = BreadcrumbIndexTemplate;

  function BreadcrumbView(presenter) {
    var $module, breadcrumb;
    this.presenter = presenter;
    breadcrumb = this.presenter.breadcrumb;
    if (!$(BREADCRUMB_SELECTOR).length) {
      return;
    }
    $module = $(BREADCRUMB_SELECTOR);
    this.$el = $module;
  }

  BreadcrumbView.prototype.render = function() {
    return this.$el.replaceWith(this.toHtml());
  };

  BreadcrumbView.prototype.toHtml = function() {
    return this.template.render(this.presenter);
  };

  BreadcrumbView.prototype.getSelector = function() {
    var selector;
    selector = $(BREADCRUMB_SELECTOR);
    if (selector.length) {
      return selector;
    }
  };

  return BreadcrumbView;

})(Backbone.View);

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWRjYWJhbGxlcm8vbmFwaXN0cmFuby9idWlsZC8xNDkyNDY3OTc1Mzc5LTM3OTUyL3N0YWdpbmctMjAxNy4wNC4xN18yMi4xNS9nb29kcy9tb2R1bGVzL2JyZWFkY3J1bWIvZnJvbnRlbmQvdmlld3MvYnJlYWRjcnVtYi5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9hZGNhYmFsbGVyby9uYXBpc3RyYW5vL2J1aWxkLzE0OTI0Njc5NzUzNzktMzc5NTIvc3RhZ2luZy0yMDE3LjA0LjE3XzIyLjE1L2dvb2RzL21vZHVsZXMvYnJlYWRjcnVtYi9mcm9udGVuZC92aWV3cy9icmVhZGNydW1iLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLGlEQUFBO0VBQUE7OztBQUFBLFFBQUEsR0FBVyxPQUFBLENBQVEsVUFBUjs7QUFDWCx1QkFBQSxHQUEwQixPQUFBLENBQVEsMkJBQVI7O0FBRTFCLE1BQU0sQ0FBQyxPQUFQLEdBQXVCO0FBQ3JCLE1BQUE7Ozs7RUFBQSxtQkFBQSxHQUFzQjs7MkJBRXRCLFFBQUEsR0FBVTs7RUFFRyx3QkFBQyxTQUFEO0FBQ1gsUUFBQTtJQURZLElBQUMsQ0FBQSxZQUFEO0lBQ1gsYUFBYyxJQUFDLENBQUE7SUFDaEIsSUFBQSxDQUFjLENBQUEsQ0FBRSxtQkFBRixDQUFzQixDQUFDLE1BQXJDO0FBQUEsYUFBQTs7SUFFQSxPQUFBLEdBQVUsQ0FBQSxDQUFFLG1CQUFGO0lBQ1YsSUFBQyxDQUFBLEdBQUQsR0FBTztFQUxJOzsyQkFPYixNQUFBLEdBQVEsU0FBQTtXQUNOLElBQUMsQ0FBQSxHQUFHLENBQUMsV0FBTCxDQUFpQixJQUFDLENBQUEsTUFBRCxDQUFBLENBQWpCO0VBRE07OzJCQUdSLE1BQUEsR0FBUSxTQUFBO1dBQ04sSUFBQyxDQUFBLFFBQVEsQ0FBQyxNQUFWLENBQWlCLElBQUMsQ0FBQSxTQUFsQjtFQURNOzsyQkFHUixXQUFBLEdBQWEsU0FBQTtBQUNYLFFBQUE7SUFBQSxRQUFBLEdBQVcsQ0FBQSxDQUFFLG1CQUFGO0lBQ1gsSUFBbUIsUUFBUSxDQUFDLE1BQTVCO0FBQUEsYUFBTyxTQUFQOztFQUZXOzs7O0dBbEIrQixRQUFRLENBQUMifQ==
